import { render, staticRenderFns } from "./newsection.vue?vue&type=template&id=d1f5ec10"
import script from "./newsection.vue?vue&type=script&lang=js"
export * from "./newsection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports